/* eslint-disable complexity */
/* eslint-disable max-lines-per-function */
import { ComponentController as BpController } from '@rta/rta-blueprint-component';
import { BlueprintInstanceType, Obstruction, Size } from '@rta/rta-blueprint-library';
import { Box, Stack } from '@chakra-ui/react';
import { useEffect, useState, type JSX } from 'react';

import { ContextPanelContent } from './context-panel-content';
import { InlineNumberInput } from './controls';
import { lang } from '@lang';
import { useDesign } from '@hooks';

export type ObstructionPropertiesPanelProps = {
	id: string | null;
};

export const ObstructionPropertiesPanel = ({ id }: ObstructionPropertiesPanelProps): JSX.Element => {
	const [controller] = useDesign<BpController>();
	const [obstruction, setObstruction] = useState<Obstruction | null>(null);
	const [size, setSize] = useState<Size>();

	const readonly = controller?.readonly ?? true;

	useEffect(() => {
		if (controller) {
			const refMap = controller.kitchen?.getReferenceMap(id ?? '');
			if (refMap?.type === BlueprintInstanceType.Obstruction && refMap.obstruction) {
				setObstruction(refMap.obstruction);
				const frontPanel = refMap.obstruction.frontPanel;
				setSize(frontPanel?.size as Size);
			}
		}
	}, [controller, id]);

	if (!controller || !obstruction || !size) return <></>;

	return <ContextPanelContent title="Obstruction Properties">
		<Box width="100%" mb="5px" mt="5px" padding="5px" textAlign="left" borderLeft="1px solid grey" borderBottom="1px solid darkgrey">
			<Stack spacing="12px">
				<InlineNumberInput
					label="Width" min={2} max={300}
					enabled={!readonly}
					value={ size.width ?? 0 }
					onChange={(valueString) => {
						if (readonly) return;
						const newWidth = parseFloat(valueString);
						setSize({ ...size, width: newWidth });
						const frontPanel = obstruction.frontPanel;
						if (frontPanel) {
							frontPanel.size = { ...frontPanel.size, width: newWidth };
						}
					}}
				/>
				<InlineNumberInput
					label="Depth" min={2} max={240}
					enabled={!readonly}
					value={ size.depth ?? 0 }
					onChange={(valueString) => {
						if (readonly) return;
						const newDepth = parseFloat(valueString);
						setSize({ ...size, depth: newDepth });
						const frontPanel = obstruction.frontPanel;
						if (frontPanel) {
							frontPanel.size = { ...frontPanel.size, depth: newDepth };
						}
					}}
				/>
				<InlineNumberInput
					label="Height" min={2} max={60}
					enabled={!readonly}
					value={ size.height ?? 0 }
					onChange={(valueString) => {
						if (readonly) return;
						const newHeight = parseFloat(valueString);
						setSize({ ...size, height: newHeight });
						const frontPanel = obstruction.frontPanel;
						if (frontPanel) {
							frontPanel.size = { ...frontPanel.size, height: newHeight };
						}
					}}
				/>
			</Stack>
		</Box>
	</ContextPanelContent>;
};
